import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { PaymentAccount } from './payment-account';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class OrganizationPaymentAccount extends AbstractModel {
  @autoserialize
  organizationId?: number;

  @autoserializeAs(PaymentAccount)
  paymentAccount: PaymentAccount;

  @autoserialize
  default: boolean;

  @autoserialize
  active: boolean;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  modifiedByUserId: number;

  @autoserialize
  deactivatedByUserId: number;

  @autoserialize
  deactivatedAt: Date;
}
